import { useBienContext } from '../BienContext'

import DetailTemplate from '@/components/DetailTemplate'
import EditButtons from '../EditButtons'
import { Textarea } from '@/components/ui'
import Form from './Form'

export default () => {
  const { bien, updatedSections, markSectionAsUpdated, 
    isPendingAction, closeModalCallback
  } = useBienContext()

  const SECTION_ID = 'structure'
  const SECTION_TITLE = "Structure / travaux / sinistres"

  const modalContent = <Form title={SECTION_TITLE}/>
  
  const editButton = <EditButtons
    bienId={bien.id}
    isArchived={!!bien.archived_at}
    isPendingAction={isPendingAction}
    title="Modifier structure / travaux / sinistres"
  />

  return(
    <DetailTemplate
      title={SECTION_TITLE}
      sectionId={SECTION_ID}
      bodyProps={{columns: 5}}
      updatedSections={updatedSections}
      loading={false}
      isPendingAction={isPendingAction}
      editButton={editButton}
      modalContent={modalContent}
      onUpdateSuccess={markSectionAsUpdated}
      onCloseModalCallback={closeModalCallback}
    >
      <div className='space-y-4'>
        <Textarea.Display label="Etat toiture" value={bien.toiture} className="flex flex-col items-start" />
      </div>
      <div className='space-y-4'>
      <Textarea.Display label="Etat façade" value={bien.facade} className="flex flex-col items-start" />
      </div>
      <div className='space-y-4'>
      <Textarea.Display label="Sinistres" value={bien.sinistres} className="flex flex-col items-start" />
      </div>
      <div className='space-y-4'>
      <Textarea.Display label="Travaux" value={bien.travaux} className="flex flex-col items-start" />
      </div>
      <div className='space-y-4'>
      <Textarea.Display label="Assurances D/O + date" value={bien.assurances} className="flex flex-col items-start" />
      </div>

    </DetailTemplate>
  )
}